// extracted by mini-css-extract-plugin
export default {"wrap":"bf_c2","navItem":"bf_b5"};